@for (period of dayPeriods; track period) {
  <div
    id="greeting-{{period.id}}"
    class="p-2"
    [hidden]="!showGreeting(period.id)">
    {{period.label | translate: { name: firstName } }}
  </div>
}